import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-xl text-primary-400">
                <i className="ri-book-read-line"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">木瓜漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              海量正版漫画免费在线阅读平台。热血、恋爱、悬疑、搞笑等多种类型，随时随地畅享漫画乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="space-y-2">
              {['热血', '恋爱', '悬疑', '搞笑', '奇幻'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat === '热血' ? 'rexue' : cat === '恋爱' ? 'lianai' : cat === '悬疑' ? 'xuanyi' : cat === '搞笑' ? 'gaoxiao' : 'qihuan'}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">漫画分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@muguamanhua.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </span>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </span>
                北京市朝阳区漫画大厦
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 木瓜漫画 muguamanhua.com 版权所有 | 京ICP备2026088888号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}